// TEAMS Website - Navbar Component
// Main navigation with language switcher

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n.js';
import i18n from 'i18next';
import LanguageSwitcher from '../ui/LanguageSwitcher.jsx';
import '../../styles/main.scss';

const Navbar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  // Navigation items
  const navItems = [
    { path: '/association', label: t('nav.association') },
   // { path: '/events', label: t('nav.events') },
    //{ path: '/press', label: t('nav.press') }
  ];

  // Handle language change
  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
  };

  // Handle mobile menu toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        {/* Logo */}
        <Link to="/" className="navbar__logo">
          <span className="navbar__logo-text">TEAMS</span>
          <span className="navbar__logo-subtitle">
            {t('hero.tagline')}
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar__nav-desktop">
          <ul className="navbar__nav-list">
            {navItems.map((item) => (
              <li key={item.path} className="navbar__nav-item">
                <Link
                  to={item.path}
                  className={`navbar__nav-link ${
                    location.pathname === item.path ? 'navbar__nav-link--active' : ''
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Right side: Language switcher and CTA */}
        <div className="navbar__actions">
          <LanguageSwitcher
            currentLanguage={i18n.language}
            onLanguageChange={handleLanguageChange}
          />
          
          <Link to="/#booking" className="navbar__cta">
            {t('nav.booking')}
          </Link>

          {/* Mobile menu button */}
          <button
            className="navbar__mobile-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className="navbar__hamburger">
              <span className={`navbar__hamburger-line ${isMobileMenuOpen ? 'navbar__hamburger-line--open' : ''}`} />
              <span className={`navbar__hamburger-line ${isMobileMenuOpen ? 'navbar__hamburger-line--open' : ''}`} />
              <span className={`navbar__hamburger-line ${isMobileMenuOpen ? 'navbar__hamburger-line--open' : ''}`} />
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`navbar__mobile-menu ${isMobileMenuOpen ? 'navbar__mobile-menu--open' : ''}`}>
        <div className="navbar__mobile-container">
          <ul className="navbar__mobile-nav-list">
            {navItems.map((item) => (
              <li key={item.path} className="navbar__mobile-nav-item">
                <Link
                  to={item.path}
                  className={`navbar__mobile-nav-link ${
                    location.pathname === item.path ? 'navbar__mobile-nav-link--active' : ''
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li className="navbar__mobile-nav-item">
              <Link to="/#booking" className="navbar__mobile-nav-link navbar__mobile-nav-link--cta">
                {t('nav.booking')}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
